import { render, staticRenderFns } from "./SimplePlaceholder.vue?vue&type=template&id=f11b42ce"
import script from "./SimplePlaceholder.vue?vue&type=script&lang=js"
export * from "./SimplePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports